export class CommonModel {
    TEXT: string;
    VALUE: string;
}